import { faArrowRight } from "@fortawesome/pro-regular-svg-icons";
import { Dropdown, Icon, Tag } from "@intility/bifrost-react";
import { type CSSProperties, type ReactNode, useState } from "react";

// The tag of a client or a platform. Clicking it never takes you anywhere by
// itself: it opens a small menu with "Go to client" or "Go to platform", and
// only that leaves the page.
export function GoToTag({
  children,
  kind,
  onGo,
  style,
  title,
}: {
  /** The tag's text. */
  children: ReactNode;
  /** What the tag stands for; the menu says "Go to <kind>". */
  kind: "client" | "platform";
  /** Where to go, called when the menu's option is chosen. */
  onGo: () => void;
  style?: CSSProperties;
  title?: string;
}) {
  const [open, setOpen] = useState(false);

  return (
    <Dropdown
      visible={open}
      onHide={() => setOpen(false)}
      placement="bottom-start"
      content={
        // The menu renders in a portal, but React still bubbles its clicks to
        // whatever the tag sits in (a card, a table row), which would open it.
        // biome-ignore lint/a11y/useKeyWithClickEvents: only stops propagation.
        // biome-ignore lint/a11y/noStaticElementInteractions: only stops propagation.
        <div onClick={(e) => e.stopPropagation()}>
          <button
            type="button"
            onClick={() => {
              setOpen(false);
              onGo();
            }}
          >
            <Dropdown.Item>
              {/* The text at the left, the arrow at the far right. */}
              <span
                style={{
                  alignItems: "center",
                  display: "flex",
                  gap: 16,
                  justifyContent: "space-between",
                }}
              >
                Go to {kind}
                <Icon icon={faArrowRight} />
              </span>
            </Dropdown.Item>
          </button>
        </div>
      }
    >
      <Tag
        aria-expanded={open}
        aria-haspopup="true"
        onClick={() => setOpen((v) => !v)}
        style={style}
        title={title}
      >
        {children}
      </Tag>
    </Dropdown>
  );
}
